export enum ConsentAcceptanceType {
  FORWARDED = "FORWARDED",
  CLICKED = "CLICKED",

  THIRD_PARTY = "THIRD_PARTY"
}
